export type ChatToolRendererKind =
  | 'ask-user'
  | 'document-generation'
  | 'hidden'
  | 'safe-fallback'
  | 'web-activity';

const TOOL_RENDERERS: Record<string, ChatToolRendererKind> = {
  ask_user: 'ask-user',
  createDocument: 'hidden',
  fetch_url: 'web-activity',
  generate_document: 'document-generation',
  revise_document: 'document-generation',
  web_search: 'web-activity',
};

export function resolveChatToolRenderer(toolName: string): ChatToolRendererKind {
  return TOOL_RENDERERS[toolName] ?? 'safe-fallback';
}

export function getSafeToolStatusMessage(state: string) {
  if (state === 'output-error') {
    return 'L’outil n’a pas pu terminer son traitement.';
  }

  if (state === 'output-denied') {
    return 'L’exécution de l’outil a été refusée.';
  }

  if (state === 'output-available') {
    return 'Le traitement est terminé.';
  }

  return 'Traitement en cours…';
}

